/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RavenDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _Log = require('../Log');

var _raven = require('raven');

var _raven2 = _interopRequireDefault(_raven);

var _util = require('util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Raven/Sentry logging
 */
let RavenDriver = exports.RavenDriver = function (_AbstractDriver) {
  _inherits(RavenDriver, _AbstractDriver);

  /**
   * @param {String} dsn
   * @param {Object} options
   */
  function RavenDriver(dsn) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, RavenDriver);

    var _this = _possibleConstructorReturn(this, (RavenDriver.__proto__ || Object.getPrototypeOf(RavenDriver)).call(this));

    options = _util2.default._extend(options, {
      maxMessageLength: 256
    });

    _this._clients = {};

    for (let levelKey in _Log.Log.LEVELS) {
      if (!_Log.Log.LEVELS.hasOwnProperty(levelKey)) {
        continue;
      }

      let nativeLevel = RavenDriver._mapLevel(_Log.Log.LEVELS[levelKey]);

      options.level = nativeLevel;

      _this._clients[nativeLevel] = new _raven2.default.Client(dsn, options);
    }
    return _this;
  }

  /**
   * @returns {Raven.Client[]}
   */


  _createClass(RavenDriver, [{
    key: 'log',


    /**
     * @param {String} msg
     * @param {String} level
     * @param {*} context
     */
    value: function log(msg, level, context) {
      let nativeLevel = RavenDriver._mapLevel(level);

      this._clients[nativeLevel].captureMessage(msg, {
        extra: context,
        tags: {
          originalLevel: level
        }
      });
    }

    /**
     * @param {String} level
     * @returns {string}
     * @private
     */

  }, {
    key: 'clients',
    get: function get() {
      return this._clients;
    }
  }], [{
    key: '_mapLevel',
    value: function _mapLevel(level) {
      let nativeLevel = 'info';

      switch (level) {
        case _Log.Log.EMERGENCY:
        case _Log.Log.CRITICAL:
          nativeLevel = 'fatal';
          break;
        case _Log.Log.ALERT:
        case _Log.Log.WARNING:
        case _Log.Log.NOTICE:
          nativeLevel = 'warning';
          break;
        case _Log.Log.ERROR:
          nativeLevel = 'error';
          break;
        case _Log.Log.INFO:
          nativeLevel = 'info';
          break;
        case _Log.Log.DEBUG:
          nativeLevel = 'debug';
          break;
      }

      return nativeLevel;
    }
  }]);

  return RavenDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/RavenDriver.js
// module id = 409
// module chunks = 0